import "./LadingPageCardTw0.css";
import planet from "../../../assets/icons/planet-earth.png";
import bulding from "../../../assets/icons/bulding.png";
import group from "../../../assets/icons/group.png";
import flowchart from "../../../assets/Images/flowcahrt.png";
import { useEffect, useRef } from "react";

const LadingPageCardTwo = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll(".animate-on-scroll").forEach((el, i) => {
              el.style.animationDelay = `${i * 0.15}s`;
              el.classList.add("animated");
            });
          }
        });
      },
      { threshold: 0.15 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div className="LadingPageCardTwo" ref={sectionRef}>
      <div className="LadingPageCardTwo-container">
        <div className="LadingPageCardTwo-container-left animate-on-scroll">
          <h4>Get the Advantage in your Digital HR Transformation Journey</h4>
          <p>
            Digital HR transformation is necessary for organisational success.
            Our team at Adrenalin, with over 20 years of HR domain expertise,
            delivers innovative solutions that focus on customer satisfaction
            and empowering talent. We help HR and employees succeed.
          </p>
        </div>

        <div className="LadingPageCardTwo-container-center animate-on-scroll">
          <div className="card-one">
            <img src={planet} alt="icon" />
            <p>65+</p>
            <label>Countries</label>
          </div>
          <div className="cards">
            <div>
              <img src={bulding} alt="icon" />
              <p>1500+</p>
              <label>Clients</label>
            </div>
            <div>
              <img src={group} alt="icon" />
              <p>2.5M+</p>
              <label>Users</label>
            </div>
          </div>
        </div>

        <div className="LadingPageCardTwo-container-right animate-on-scroll">
          <h4>Hire to Retire Employee Experience</h4>
          <p>
            Our end-to-end robust applications for each process in the employee
            lifecycle are designed to ensure that you hire the right talent for
            the job and offer the best employee experience. Leverage our
            solutions to deliver measurable ROI.
          </p>
        </div>
      </div>
      <div className="flowchart-img animate-on-scroll">
        <img src={flowchart} alt="flowchart" />
      </div>
    </div>
  );
};

export default LadingPageCardTwo;
